export default {
  1: "bloccata",
  2: "confermata",
  3: "pagata",
}
